import React, { useEffect, useRef, useState } from 'react';
import { BusinessReportArray } from '../../../types/businessReport/BusinessReportGetResponse';
import EditAndDeleteButton from '../../../components/button/EditAndDeleteButton';
import { formatProjectName } from '../../../utils/formatProjectName';
import { differenceInCalendarDays, startOfDay } from 'date-fns';
import { stringToYmdDate } from '../../../utils/datepickerUtil';
import { MAN_HOURS_CATEGORY_KEYS } from '../../../types/businessReport/BusinessReportPutRequest';
import { FormCheck } from 'react-bootstrap';

interface Props {
  item: BusinessReportArray;
  onEdit: (item: BusinessReportArray) => void;
  onDelete: (item: BusinessReportArray) => void;
}

const RenderBusinessReportRow: React.FC<Props> = ({
  item,
  onEdit,
  onDelete,
}) => {
  // 1週間以内判定（ボタン活性/非活性に使用）
  const canOperateWithinAWeek = (dateStr: string) => {
    const target = stringToYmdDate(dateStr);
    if (target === null) return;
    const today = startOfDay(new Date());
    const diff = differenceInCalendarDays(today, startOfDay(target));
    return diff <= 7;
  };
  const canOperate = canOperateWithinAWeek(item.date);

  const formatYmdToSlash = (ymd: string) => {
    return ymd.replace(/-/g, '/');
  };

  // ボタン非表示の場合に行の高さを揃えるための処理
  const [rowHeight, setRowHeight] = useState<number | undefined>(undefined);
  const tdRefs = useRef<(HTMLTableCellElement | null)[]>([]);

  useEffect(() => {
    if (tdRefs.current.length > 0) {
      const heights = tdRefs.current.map((td) => (td ? td.clientHeight : 0));
      const maxHeight = Math.max(...heights);
      setRowHeight(maxHeight);
    }
  }, [tdRefs.current]);

  return (
    <>
      <td
        ref={(el) => {
          tdRefs.current[0] = el;
        }}
      >
        {formatYmdToSlash(item.date)}
      </td>
      <td
        ref={(el) => {
          tdRefs.current[1] = el;
        }}
      >
        {item.projectNo}
      </td>
      <td
        ref={(el) => {
          tdRefs.current[2] = el;
        }}
      >
        {formatProjectName(item.projectName)}
      </td>
      {MAN_HOURS_CATEGORY_KEYS.map((key) => (
        <td key={key}>
          <FormCheck
            type="radio"
            name={`manHoursCategory-edit-${item.id}`}
            checked={item.manHoursCategory === key}
          />
        </td>
      ))}
      <td
        ref={(el) => {
          tdRefs.current[3] = el;
        }}
      >
        {item.startTime}
      </td>
      <td
        ref={(el) => {
          tdRefs.current[4] = el;
        }}
      >
        {item.endTime}
      </td>
      <td
        ref={(el) => {
          tdRefs.current[5] = el;
        }}
      >
        {item.manHoursTotal}
      </td>
      <td
        className="d-flex justify-content-center align-items-center"
        style={{ height: rowHeight }}
      >
        {
          canOperate ? (
            <EditAndDeleteButton
              onEdit={() => onEdit(item)}
              onDelete={() => onDelete(item)}
              editingRowIndex={item.id}
            />
          ) : (
            <div style={{ height: '100%' }} />
          ) /* 非活性時はボタン自体を非表示 */
        }
      </td>
    </>
  );
};

export default RenderBusinessReportRow;
